var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9017 47.1521C32.4372 45.6876 30.0628 45.6876 28.5983 47.1521L27.6516 48.0988C26.1871 49.5633 26.1871 51.9376 27.6516 53.4021L41.0983 66.8491C42.5628 68.3137 44.9372 68.3137 46.4017 66.8491L72.3484 40.9018C73.8129 39.4373 73.8129 37.063 72.3484 35.5985L71.4017 34.6518C69.9372 33.1873 67.5628 33.1873 66.0983 34.6518L46.4017 54.3488C44.9372 55.8134 42.5628 55.8134 41.0983 54.3488L33.9017 47.1521Z",
    fill: "#00840D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    stroke: "#00840D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeCheck);
export default __webpack_public_path__ + "static/media/fe-check.58e0489de2594e6039308d65b8e5db6a.svg";
export { ForwardRef as ReactComponent };